import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  ClickAwayListener,
  FormControl,
  Grow,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  type SelectProps,
} from "@mui/material";
import { type Language } from "../types/language";
import type { FrontendId } from "../store/UserStore";
import { LANGUAGE_STORAGE_KEY as PLATFORM_LANGUAGE_STORAGE_KEY } from "@ai/uimain/src/constants/localStorageKeys";
import { LANGUAGE_STORAGE_KEY as TRAINER_LANGUAGE_STORAGE_KEY } from "@ai/uitrainer/src/constants/localStorageKeys";

export const LanguageSwitcher = ({
  showLabel = true,
  selectProps,
  frontendId,
}: {
  showLabel?: boolean;
  frontendId: FrontendId;
  selectProps?: SelectProps;
}) => {
  const { i18n, t } = useTranslation();

  const [open, setOpen] = useState(false);
  const selectRef = useRef(null);

  const changeLanguage = async (lng: Language) => {
    setOpen(false);
    await i18n.changeLanguage(lng);
    localStorage.setItem(
      frontendId === "trainer"
        ? TRAINER_LANGUAGE_STORAGE_KEY
        : PLATFORM_LANGUAGE_STORAGE_KEY,
      lng
    );
  };

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Box sx={{ minWidth: 120, position: "relative" }}>
        <FormControl fullWidth>
          {showLabel && (
            <InputLabel id="language-select-label">{t("language")}</InputLabel>
          )}

          <Select
            ref={selectRef}
            labelId="language-select-label"
            id="language-select"
            value={i18n.language}
            label={t("language")}
            displayEmpty
            open={open}
            onClick={() => setOpen((prev) => !prev)}
            onChange={(e) => changeLanguage(e.target.value as Language)}
            MenuProps={{ sx: { display: "none" } }}
            {...selectProps}
          >
            <MenuItem value="en">English</MenuItem>
            <MenuItem value="ru">Русский</MenuItem>
          </Select>

          <Grow in={!!open}>
            <Paper
              sx={{
                position: "absolute",
                zIndex: 1,
                top: "100%",
                width: "100%",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.1))",
                py: 1,
              }}
            >
              <MenuItem
                component={"div"}
                sx={{ cursor: "pointer" }}
                onClick={() => changeLanguage("en")}
              >
                English
              </MenuItem>
              <MenuItem
                component={"div"}
                sx={{ cursor: "pointer" }}
                onClick={() => changeLanguage("ru")}
              >
                Русский
              </MenuItem>
            </Paper>
          </Grow>
        </FormControl>
      </Box>
    </ClickAwayListener>
  );
};
